import React, { useState } from "react";
import LandingPage from "./LandingPage";
import OptInMessagePage from "./OptInMessagePage";
import { parse } from "qs";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import ErrorBoundary from "components/Library/ErrorBoundary";
import generateReferralUrl from "../utils/generateReferralUrl";
import { REFERRAL_PROGRAMS } from "../../config/constants";

export default function ReferralPage(props) {
  const [submitted, updateSubmitted] = useState(false);

  // Get the referral code from the query params to include on form submit
  const queryParams = parse(props.location.search.slice(1));
  const referralCode = queryParams.code || "";
  const newsletter = props.match.params.newsletter;
  const referralVars = REFERRAL_PROGRAMS[newsletter];
  return (
    <ErrorBoundary>
      <Helmet>
        <title>{referralVars.title}</title>
        <meta property="og:title" content={referralVars.title} />
        <meta property="og:description" content={referralVars.description} />
        <meta name="description" content={referralVars.description} />
        <meta
          property="og:url"
          content={generateReferralUrl(referralVars.slug, referralCode)}
        />
        <meta
          property="og:image"
          content={require("assets/" + referralVars.bannerImage)}
        />
      </Helmet>
      {submitted ? (
        <OptInMessagePage newsletter={newsletter} />
      ) : (
        <LandingPage
          updateSubmitted={updateSubmitted}
          referralCode={referralCode}
          referralVars={referralVars}
        />
      )}
    </ErrorBoundary>
  );
}

ReferralPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};
